<template>
	<!-- banner -->
	<section v-if="topoProdutos != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoProdutos[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoProdutos[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- produto -->
	<section>
		<div class="produtos">
			<div v-if="ProdutoSelecionado != ''" class="container">
				<div class="row">
					<div class="col-lg-6 slide-produto">
						<v-carousel show-arrows="hover" hide-delimiters>
							<v-carousel-item v-for="produtoImagens in ProdutoSelecionado.insInstitucionalImagens"
								:key="produtoImagens.itgId" :src="$imgURL + produtoImagens.itgUrlImagem"
								contain></v-carousel-item>
						</v-carousel>
					</div>
					<!-- galeria produtos -->
					<div class="col-lg-6 heading-section">
						<span class="subheading">{{
							ProdutoSelecionado.insInstitucionalSegmentos[0].insSegmentos.sgiNomeSegmento }}</span>
						<h3 class="strong tit-prod">{{ ProdutoSelecionado.itiNome }}</h3>
						<p v-html="ProdutoSelecionado.itiResumo1"></p>
						<div style="display: inline-flex;">

							<form class=" contact-form form-quant">
								<div class="row">
									<div class="col-md-6">
										<span>Quantidade</span>
										<div class="form-group">
											<input v-model="QtdeProduto" type="number" class="form-control">
										</div>
									</div>
								</div>
							</form>
						</div>
						<div>
							<p>
							<a class="btn btn-primary py-3 px-4" href="#" @click.prevent="AdicionaCarrinho()">
								Adicionar Carrinho
							</a></p>
						</div>
						<div>
							<button onclick="history.back()"
								style="padding-top: 15px; font-size: 14px; cursor: pointer;">
								← Voltar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END produtos -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'
import { useRoute } from 'vue-router';

export default {
	name: 'ProdutosDetalheView',
	components: {

	},
	setup() {
		const route = useRoute();
		const id = route.params.id;
		const nome = route.params.nome;
		return {
			id,
			nome
		};
	},

	data: () => ({
		topoProdutos: [],
		ProdutoSelecionado: [],
		QtdeProduto: 1,
		DadosCompra: {
			produtos: [],
			mensagem: [],
			agenda: [],
			foto: [],
			avulsos: [],
			baloes: [],
			informacao: [],
			pagamento: [],
			cupom: [],
		},
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Produtos - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},
		removerTagsHTML(html) {
			const element = document.createElement('div');
			element.innerHTML = html;
			return element.textContent || element.innerText || '';
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
		calculatotal(value) {
			var valorAvulsos = 0;
			let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
			if (dadosArmazenados) {
				dadosArmazenados = JSON.parse(dadosArmazenados);

				if (dadosArmazenados.avulsos != '') {

					dadosArmazenados.avulsos.forEach(item => {
						valorAvulsos += item.praValorPor;
					});
				}
			}
			this.valorTotal = value.proProdutosPrecos[0].ppcValorPor + valorAvulsos;
		},
		AdicionaCarrinho() {
			let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
			if (dadosArmazenados) {
				dadosArmazenados = JSON.parse(dadosArmazenados);
				this.ProdutoSelecionado.proQtde = this.QtdeProduto;  //pegando a quantidade
				dadosArmazenados.produtos.push(this.ProdutoSelecionado); //pegando o produto selecionado
				localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados)); //gravando no localstorage
				this.$store.commit('updateVariavelHeader2', dadosArmazenados.produtos.length);
				this.$router.push('/carrinho')
			}
		},
	},

	created() {
		//quando entrar na tela a primeira vez, grava o localstorage vazio
		let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
		if (!dadosArmazenados) {
			dadosArmazenados = this.DadosCompra;
			localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados))
		}

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/38/topoprodutos/0/x')
			.then(response => {
				this.topoProdutos = response.data;
				//console.log('topo produtos')
				//console.log(this.topoProdutos)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca produtos
		axios.get('/Process/InsInstitucional/GetById/' + this.id)
			.then(response => {
				this.ProdutoSelecionado = response.data;
				this.carregaMetas(this.removerTagsHTML(this.ProdutoSelecionado.itiResumo1));
				//console.log('this.ProdutoSelecionado')
				//console.log(this.ProdutoSelecionado)

			})
			.catch(error => {
				console.error(error);
			});

	},
}

</script>

<style scoped></style>
